import { ArrowPathIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "src/helpers/classNames";

const Button = ({ buttonClasses, buttonStyles = {}, buttonType, buttonIconPosition, buttonIconClass, buttonLabel, buttonLabelClasses, buttonFunction = () => {}, buttonHasLink, buttonLink, isDisable = false, loading = false, success = false, ...props }) => {
  return (
    <>
      {buttonHasLink ? (
        <Link
          to={buttonLink}
          style={buttonStyles}
          className={classNames("relative flex h-[47px] items-center justify-center gap-2 overflow-hidden rounded-md bg-gray-700 px-3 py-0 text-lg text-white transition-all duration-200 md:h-[40px] 2xl:h-[47px]", buttonClasses, isDisable ? "pointer-events-none opacity-75" : "")}>
          {buttonIconPosition === "left" && <props.buttonIcon className={classNames("h-5 w-5", buttonIconClass)} />}
          {buttonLabel && <span className={classNames("text-base transition-all duration-200", buttonLabelClasses)}>{buttonLabel}</span>}
          {buttonIconPosition === "right" && <props.buttonIcon className={classNames("h-5 w-5", buttonIconClass)} />}
        </Link>
      ) : (
        <button
          type={buttonType}
          className={classNames("relative flex h-[47px] items-center justify-center gap-2 rounded-md bg-gray-700 px-3 py-0 text-lg text-white transition-all duration-200 md:h-[40px] 2xl:h-[47px]", buttonClasses, isDisable ? "pointer-events-none opacity-75" : "")}
          style={buttonStyles}
          onClick={buttonFunction}
          disabled={isDisable}>
          {buttonIconPosition === "left" && (
            <>
              {loading ? (
                <ArrowPathIcon className={classNames("h-5 w-5 animate-spin text-white", buttonIconClass)} />
              ) : success ? (
                <CheckCircleIcon className={classNames("h-5 w-5 text-white", buttonIconClass)} />
              ) : (
                props.buttonIcon && <props.buttonIcon className={classNames("h-5 w-5", buttonIconClass)} />
              )}
            </>
          )}
          {buttonLabel && <span className={classNames("text-base transition-all duration-200", buttonLabelClasses)}>{buttonLabel}</span>}
          {buttonIconPosition === "right" && (
            <>
              {loading ? (
                <ArrowPathIcon className={classNames("h-5 w-5 animate-spin text-white", buttonIconClass)} />
              ) : success ? (
                <CheckCircleIcon className={classNames("h-5 w-5 text-white", buttonIconClass)} />
              ) : (
                props.buttonIcon && <props.buttonIcon className={classNames("h-5 w-5", buttonIconClass)} />
              )}
            </>
          )}
        </button>
      )}
    </>
  );
};

export default Button;
